import { render, staticRenderFns } from "./InspectionCreateCardTabs.vue?vue&type=template&id=5526052d&scoped=true&"
import script from "./InspectionCreateCardTabs.vue?vue&type=script&lang=ts&"
export * from "./InspectionCreateCardTabs.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionCreateCardTabs.vue?vue&type=style&index=0&id=5526052d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5526052d",
  null
  
)

export default component.exports